import { useState } from "react";
import "./LoginPage.css";

function LoginPage({ onLoginSuccess, onClose, showRememberMe = false }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Hole Backend-URL aus localStorage
      const savedHost =
        localStorage.getItem("backendHost") || window.location.origin;

      const response = await fetch(`${savedHost}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // Wichtig: Sendet Cookies mit
        body: JSON.stringify({ username, password, rememberMe: showRememberMe && rememberMe }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setError("");
        onLoginSuccess();
      } else {
        setError(data.error || "Falscher Benutzername oder Passwort");
        setPassword("");
      }
    } catch (err) {
      setError("Login-Fehler. Bitte versuchen Sie es erneut.");
      console.error("Login error:", err);
    }
  };

  return (
    <div className="login-overlay">
      <div className="login-container">
        <div className="login-header">
          <h2 className="login-title">Login</h2>
          <button onClick={onClose} className="login-close-btn">
            ×
          </button>
        </div>

        <form onSubmit={handleLogin}>
          <div className="login-form-group">
            <label className="login-label">Benutzername</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="login-input"
            />
          </div>

          <div className="login-form-group">
            <label className="login-label">Passwort</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
            />
          </div>

          {showRememberMe && (
            <div className="login-form-group login-remember">
              <label className="login-remember-label">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="login-remember-checkbox"
                />
                Angemeldet bleiben
              </label>
            </div>
          )}

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-submit-btn">
            Anmelden
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
